import { useState, useEffect } from "react";

interface StatusBarProps { phaseLabel: string; statusText: string; }

function LiveClock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  const timeStr = time.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
  return <span className="text-[10px] font-mono tabular-nums text-foreground-500 bg-background-100/80 px-1.5 py-0.5 rounded">{timeStr}</span>;
}

function NetworkIndicator() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return (
    <div className="flex items-center gap-1">
      <span className={`w-1.5 h-1.5 rounded-full ${online ? "bg-[#10B981]" : "bg-[#E11D48]"}`} />
      <span className="text-[9px] text-foreground-400">{online ? "在线" : "离线"}</span>
    </div>
  );
}

export default function StatusBar({ phaseLabel, statusText }: StatusBarProps) {
  const now = new Date();
  const dateStr = now.toLocaleDateString("zh-CN", { month: "2-digit", day: "2-digit", weekday: "short" });
  return (
    <div className="flex items-center justify-between px-4 pt-3 pb-2">
      <div className="flex items-center gap-2">
        <span className="text-xs text-foreground-600 whitespace-nowrap">{dateStr}</span>
        <LiveClock />
        <NetworkIndicator />
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium bg-accent-100 text-accent-700">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse" />
          {statusText}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="text-[10px] text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded">{phaseLabel}</span>
        <span className="text-[10px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">模拟</span>
      </div>
    </div>
  );
}
